var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('activeinventory',{key:_vm.key,attrs:{"activeinventory":_vm.activeInventory,"allactiveinventory":_vm.allActiveInventory,"devicemakemodels":_vm.deviceMakeModels,"tableloading":_vm.tableLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }